<template>

    <div class="flex flex-col items-center">

        <h1 class="text-4xl font-bold  text-center xl:mt-40">O nás</h1>

        <div class="flex flex-col lg:flex-row">

            <div class="lg:mr-40">
                <h2 class="mt-10">Prevádzkovateľ služby</h2>
                <p>
                    <a href="https://www.develtip.com">
                        <img src="@/assets/img/develtip-logo-bw.svg" alt="" class="h-12 ">
                    </a>
                    <b>DevelTip s.r.o.</b><br>
                    Hlavná 11<br>
                    08221 Veľký Šariš<br>
                    <a href="https://www.develtip.com">develtip.com</a><br>
                </p>
            </div>

            <div>
                <h2 class="mt-10">Kontakt</h2>

                <img alt="Holubník logo" src="@/assets/img/holubnik.svg" class="h-12 ">

                <ul>
                    <li>
                        Facebook: <a href="https://www.facebook.com/holubnik.sk">Holubník</a>
                    </li>
                    <li>
                        Email: <a :href="'mailto:' + dec(em)">{{ dec(em) }}</a>
                    </li>
                    <li>
                        Tel: <a :href="'tel:' + dec(pho)">{{ dec(pho) }}</a>
                    </li>
                </ul>
            </div>

        </div>





    </div>

</template>

<script>

export default {
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'O nás',
    },
    data() {
        return {
            pho: 'KzQyMSA5MTU' + 'gMzg0IDM3Ng==',
            em: 'b2ZmaWNlQGRldmVsd' + 'GlwLmNvbQ==',
        }
    },
    methods: {
        dec(str) {
            return atob(str)
        }
    }

}

</script>

<style scoped>
h1,
h2,
h3,
p,
img {
    @apply mb-4
}

h1, h2, h3 {
    @apply font-bold
}

h2 {
    @apply text-xl
}

h3 {
    @apply text-lg
}


a {
    @apply text-gray-500
}
</style>
